import { render, staticRenderFns } from "./qs1-17.vue?vue&type=template&id=7023163f&scoped=true&"
import script from "./qs1-17.vue?vue&type=script&lang=js&"
export * from "./qs1-17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023163f",
  null
  
)

export default component.exports